<template>
  <div>
    <div style="text-align:center;">
      <img src="https://aloha-espacecom.ideal2s.net/img/logo.png" alt="support" style="width:50%;"/>
    </div>
  </div>
</template>

<script>
import script from '../../script/script.js';

export default {
  data() {
    return {
    }
  },
  mounted:function(){
    this.verifyRight();
  },
  computed:{
  },
  methods: {
    verifyRight: script.verifyRight
  }
  
}
</script>

<style>

</style>
